import React from 'react';
import { LegalPage } from './LegalPage';

export const TermsPage = () => <LegalPage page="terms" />;
